import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { Paginacao } from '@app/models/util/paginacao';
import { PagarService } from '@app/services/pagar.service';
import { PagarListaFiltros, PagarLista } from '@app/models/pagar.model';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { CDSMask } from '@app/utils/cds-mask';
import { ConsultasService } from '@app/services/consultas.service';
import debounce from '@app/utils/debounce';
import { Baixa, BaixaFormaDePagamento } from '@app/models/baixa.model';
import { IdDescricao } from '@app/models/util/id-descricao';
import { MovimentacaoService } from '@app/services/movimentacao.service';
import { PagarQuitarDados } from './pagar-quitar-dados';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { Pagar } from '@app/models/pagar.model';

import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { ParticipanteService } from '@app/services/participante.service';
import { UtilitarioService } from '@app/services/utilitario.service';

@Component({
  selector: 'app-pagar-lista',
  templateUrl: 'pagar-lista.component.html',
  styleUrls: ['pagar-lista.component.scss']
})
export class PagarListaComponent implements OnInit {
  //uso geral de modal
  modalRef: BsModalRef;
  lstErrosModal: string[];
  
  _debounce: any;
  _pesquisa: any;
  
  //modal de pagamento múltiplo
  tipo: string;
  documentoId: number;
  valor: number;
  valorTotal: number;
  dataPagamento: string;
  baixasLista: Baixa[] = [];
  formaDePagamento: BaixaFormaDePagamento = new BaixaFormaDePagamento();
  lstRecibos: PagarLista[] = [];
  lstRecibosTemp: PagarLista[];
  lstRecibosBaixa: Baixa[] = [];
  lstPagarMultiplo: PagarLista[] = [];

  modalPagarId: number = 0;
  
  //interface
  filtros = new PagarListaFiltros();
  paginacao: Paginacao = new Paginacao();
  cdsMask: CDSMask = new CDSMask();
  lstErros: string[] = [];
  lstPagar: PagarLista[] = [];
  lstParticipante: Array<any> = [{}];
  lstUnidade: Array<any> = [{}];
  lstContas: IdDescricao[];
  lstFormaDePagamento: IdDescricao[];
  lstBanco: any[];
  lstTipoDR: any[];
  
  //baixa manual
  quitarModalDados = new PagarLista();
  tipoOperacaoBaixaManual: 'QUITAR' | 'DESQUITAR';
  
  //editar modal
  editarModalDados = new Pagar();
  
  //parciais pagar
  mapeamentoParciais: number;
  lstParciais: PagarLista[] = [];
  
  totalPagar = 0;
  totalPagas = 0;
  

  //controladores
  pesquisando: boolean;
  pagando: boolean;
  editando: boolean;
  
  //permissões
  acessoOutrasUnidades: boolean;
  acessoNovoPagar: boolean;
  acessoEditarTituloPago: boolean;
  MovimentarTodosOsCaixas: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pagarService: PagarService,
    private consultasService: ConsultasService,
    private modalService: BsModalService,
    @Inject(ToastrService) public toastr: ToastrService,
    private movimentacaoService: MovimentacaoService,
    private usuarioTipoService: UsuarioTipoService,
    private participanteService: ParticipanteService
  ) {

    this.lstFormaDePagamento = [];
    this.lstPagarMultiplo = [];
  }

  ngOnInit() {
    this.participanteService.verificaPermissaoUsuario(0, 'MovimentarTodosOsCaixas')
      .subscribe(data => {
        this.MovimentarTodosOsCaixas = data;
        this.consultasService.consultar('CONTA').subscribe((data) => (this.lstContas = data));
      },
      error => this.consultasService.consultar('CONTA_USUARIO').subscribe((data) => (this.lstContas = data))
    );
    this.lstUnidade.push({ Id: 0, Descricao: 'Sem filtro' });
    this.consultasService.consultar('UNIDADE_S_RATEIO').subscribe((data) => this.lstUnidade.push(...data));
    this.consultasService.consultar('BANCO').subscribe((data) => (this.lstBanco = data));
    this.consultasService.consultar('FORMADEPAGAMENTO_D').subscribe((data) => (this.lstFormaDePagamento = data));
    this.consultasService.consultar('DR_D').subscribe(data => this.lstTipoDR = data);

    this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
      (permissoes: any) =>{
        this.acessoOutrasUnidades = permissoes.find(x => x.Descricao == 'VisualizarOutrasUnidades').Selecionado;
        this.acessoNovoPagar = permissoes.find(x => x.Descricao == 'NovosLancamentos').Selecionado;
        this.acessoEditarTituloPago = permissoes.find(x => x.Descricao === 'EditarTituloPago').Selecionado;
        if(this.acessoOutrasUnidades){
          this.filtros.UnidadeId = 0;
        }
        else{
          this.filtros.UnidadeId = Number(UtilitarioService.retornaUnidadeUsuario());
        }
        
        this.pesquisar();
      });
  }
  pesquisar() {
    this.obterTodos(this.filtros, 1);
    this.paginacao.paginaAtual = 1;
    this.paginacao.itensPorPagina = 20;
    this.lstParciais = [];

  }

    obterTodos(filtros: PagarListaFiltros, pagina: number) {
    this.pesquisando = true;
    filtros.Pagina = pagina;

    if (!filtros.ParticipanteId) {
      filtros.ParticipanteId = 0;
    }

    if (!filtros.DemonstrativoDeResultadoId) {
      filtros.DemonstrativoDeResultadoId = 0;
    }

    this.pagarService
      .obterLista(filtros)
      .subscribe(
        (data) => {
          this.lstPagar = data.Dados;
          this.paginacao.totalDeItens = data.TotalDados;
          this.totalPagas = data.TotalPagas;
          this.totalPagar = data.TotalPagar;
          this.pesquisando = false;
        },
        erro => {
          this.pesquisando = false;
          this.toastr.warning('Realize a pesquisa novamente.');
        }
      );
  }

  pesquisarParciais(index: number) {
    if (this.lstParciais.length !== 0 && this.lstParciais[0].Participante === this.lstPagar[index].Participante) {
      this.lstParciais = [];
    } else {
      this.mapeamentoParciais = index;
      this.lstParciais = [];
      this.pagarService
        .obterParciais(this.lstPagar[index].Id)
        .toPromise()
        .then(
          (data) => {
            if (data.length === 0) {
              this.toastr.warning('Esse título não possui pagamentos parciais');
            } else {
              this.lstParciais = data;
              this.lstParciais.forEach((parcial) => {
                parcial.Participante = this.lstPagar[index].Participante;
                parcial.ProcessoId = this.lstPagar[index].ProcessoId;
                parcial.DemonstrativoDeResultado = this.lstPagar[index].DemonstrativoDeResultado;
              });
            }
          },
          () => (this.toastr.warning('Houve algum problema'))
        );
    }
  }

  gravarEdicao(pago: boolean = false){
    this.editando = true;
    const _pagar = { ...this.editarModalDados };

    if(pago){
      this.pagarService.editarTituloPago(_pagar).subscribe(
        () => {
          this.fecharModal();
          this.pesquisar();
          this.editando = false;
        },
        (data: any) => {
          this.toastr.error("Não foi possível editar o título!");
          this.editando = false;
        });
    }
    else{
      this.pagarService.gravar(_pagar).subscribe(
        () => {
          this.fecharModal();
          this.pesquisar();
          this.editando = false;
        },
        (data: any) => {
          if (data.error) {
            this.lstErrosModal = data.error.errors;
          }
          this.editando = false;
        });
    }
  }

  abrirEditarModal(pagarId: number, template: TemplateRef<any>){
    //fazer pesquisa por informações do pagar
    this.pagarService.obterPorId(pagarId).subscribe(data => { 
      this.editarModalDados = data;
      this.editarModalDados.Emissao = data.Emissao.split('T')[0];
      this.editarModalDados.Vencimento = data.Vencimento.split('T')[0];
      this.lstParticipante = [{ Id: data.Participante.Id, Descricao:data.Participante.NomeFantasia }];
    });
    this.abrirModal(template);
  }

  liberaEdicaoUnidade() : boolean {
    const titulo = this.editarModalDados;

    if(!this.acessoOutrasUnidades)
      return false;
    if(titulo.ProcessoId || titulo.RateioId)
      return false;
  
    return true;
  }

  abrirQuitarModal(tituloPagar: PagarLista, template: TemplateRef<any>): void {
    this.tipoOperacaoBaixaManual = 'QUITAR';
    this.abrirModal(template);
    this.quitarModalDados.Id = tituloPagar.Id;
    this.quitarModalDados.DataPagamento = (new Date()).toISOString();
    this.quitarModalDados.Historico = tituloPagar.Historico;
  }

  abrirDesquitarModal(tituloPagar: PagarLista, template: TemplateRef<any>): void {
    this.tipoOperacaoBaixaManual = 'DESQUITAR';
    this.abrirModal(template);
    this.quitarModalDados.Id = tituloPagar.Id;
    this.quitarModalDados.DataPagamento = null;
    this.quitarModalDados.Historico = tituloPagar.Historico;
  }

  concatenaHistorico(event: Event): void {
    this.quitarModalDados.Historico += (event.target as HTMLButtonElement).textContent;
    document.getElementById('historico').focus();
  }

  quitar() {
    const dadosQuitar = new PagarQuitarDados(
      this.quitarModalDados.Id,
      this.quitarModalDados.DataPagamento.toString(),
      this.quitarModalDados.Historico
    );

    this.pagarService.quitar(dadosQuitar).subscribe(
      (dados) => {
        this.toastr.success(`Título quitado.`, 'Sucesso');
        this.quitarModalDados = new PagarLista();
      }, (erro) => {
        this.toastr.error(`Houve algum erro para quitar o título.`, 'Erro');
        console.warn(erro);
      }, () => {
        this.fecharModal();
      }
    );
  }

  desquitar() {
    const dadosQuitar = new PagarQuitarDados(
      this.quitarModalDados.Id,
      '',
      this.quitarModalDados.Historico
    );

    this.pagarService.desquitar(dadosQuitar).subscribe(
      (dados) => {
        this.toastr.success(`Título desquitado.`, 'Sucesso');
        this.quitarModalDados = new PagarLista();
      }, (erro) => {
        this.toastr.error(`Houve algum erro para desquitar o título.`, 'Erro');
        console.warn(erro);
      }, () => {
        this.fecharModal();
      }
    );
  }

  cancelaQuitar() {
    this.fecharModal();
  }

  deletar(id: number) {
    this.pagarService.deletar(id).subscribe((data) => {
      this.obterTodos(this.filtros, 1);
    });
    this.lstErros = [];
  }

  estorno(id: number) {
    this.pagarService.realizarEstorno(id).toPromise().then(
      () => {
        this.obterTodos(this.filtros, 1);
        if (this.lstParciais.length !== 0) {
          this.lstParciais = this.lstParciais.filter((parcial) => parcial.Id !== id);
        }
      },
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
      }
    );
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtros, event.page);
  }

  searchCallback = () => true;

  checkAll(e: Event) {
    const checked = (e.target as HTMLInputElement).checked;

    if (checked) {
      this.lstPagarMultiplo = [];
      this.lstPagar.forEach((pagar) => {
        pagar.checked = true;
        this.lstPagarMultiplo.push(pagar);
      });
    } else {
      this.lstPagar.forEach((pagar) => {
        pagar.checked = false;
      });
      this.lstPagarMultiplo = [];
    }
  }

  onClick(index: number, e: Event) {
    const checked = (e.target as HTMLInputElement).checked;
    let lstTemp: PagarLista[];

    lstTemp = this.lstPagarMultiplo.filter(({ Id }) =>
      Id === this.lstPagar[index].Id
    );

    if (checked) {
      if (lstTemp.length !== 0) {
        this.toastr.warning(
          'Esse titulo já está selecionado na sua lista');
        return;
      }
      this.lstPagarMultiplo.push(this.lstPagar[index]);

    } else {
      this.lstPagarMultiplo.splice(this.lstPagarMultiplo.indexOf(this.lstPagar[index]), 1);
    }
  }

  pagarSelecionados(template: TemplateRef<any>) {
    if (this.lstPagarMultiplo.length > 0) {
        this.abrirModal(template);
        this.valorTotal = this.lstPagarMultiplo.reduce(
          (accumulator, currentValue) => accumulator + (currentValue.Valor - currentValue.ValorPago), 0);
      
    } else {
      this.toastr.info('Selecione ao menos uma conta para pagar');
    }
  }

  abrirModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }

  fecharModal() {
    this.modalRef.hide();
    this.modalRef = null;
    this.lstErrosModal = null;
  }

  fecharModalPagamento() {
    this.modalService.hide(1);
  }

  pagar(template: TemplateRef<any>) {
    const fpEncontrada = this.lstFormaDePagamento.find(
      (x) => x.Id === this.formaDePagamento.formaDePagamentoId
    );
    if (fpEncontrada) {
      this.formaDePagamento.formaDePagamentoDescricao = fpEncontrada.Descricao;
    }
    const contaEncontrada = this.lstContas.find(
      (x) => x.Id === this.formaDePagamento.contaId
    );
    if (contaEncontrada) {
      this.formaDePagamento.contaDescricao = contaEncontrada.Descricao;
    }

    if (this.lstPagarMultiplo.length <= 0) {
      this.toastr.error(
        'Selecione pelo menos uma conta para efetuar o pagamento'
      );
      this.pagando = false;
      // this.modalService.hide(1);
      this.fecharModal();
    } else {
      if (this.dataPagamento == null || this.dataPagamento === '') {
        return this.toastr.error(
          'O campo "Data do Pagamento" precisa estar preenchido'
        );
      }
      if (this.formaDePagamento.formaDePagamentoId == null) {
        return this.toastr.error(
          'O campo "Forma de pagamento" precisa estar preenchido'
        );
      }
      if (this.formaDePagamento.contaId == null) {
        return this.toastr.error(
          'O campo "Conta/Caixa" precisa estar preenchido'
        );
      }

      this.pagando = true;

      this.lstPagarMultiplo.forEach((item) => {
        const temp = JSON.parse(JSON.stringify(new Baixa()));
        item.DataPagamento = (new Date(this.dataPagamento)).toISOString();
        temp.formaDePagamentoCodigo = String(
          this.formaDePagamento.formaDePagamentoId
        );
        temp.dataPagamento = this.dataPagamento;
        temp.tipo = 'pagar';
        temp.documentoId = item.Id;
        temp.valor = item.Valor;
        temp.valorRecebido = item.ValorPago;
        temp.formaDePagamento[0] = JSON.parse(JSON.stringify(this.formaDePagamento));
        temp.formaDePagamento[0].valor = JSON.parse(JSON.stringify(temp.valor - temp.valorRecebido));

        this.baixasLista.push(temp);
      });

      this.movimentacaoService
        .baixarLista(this.baixasLista)
        .toPromise()
        .then(() => this.finalizarPagamento(true, template), () => this.finalizarPagamento(false, template));
    }
  }

  finalizarPagamento(sucesso: boolean, template: TemplateRef<any>) {
    this.pagando = false;
    this.pesquisar();

    if (!sucesso) {
      this.toastr.error('Erro no pagamento');
    } else {
      this.toastr.success('Pagamento realizado!');
      this.abrirModalRecibo(template);
    }
  }

  exibirHistoricoParcial(parcialId: number, pagarIndex: number){
    this.lstParciais.find(x => x.Id === parcialId).ExibirHistorico = !this.lstParciais.find(x => x.Id === parcialId).ExibirHistorico;
    this.exibirHistoricoPagar(pagarIndex, true);
  }

  exibirHistoricoPagar(pagarIndex: number, parcialChamou: boolean = false){
    if(parcialChamou && !this.lstPagar[pagarIndex].ExibirHistorico){
      this.lstPagar[pagarIndex].ExibirHistorico = !this.lstPagar[pagarIndex].ExibirHistorico;
    }
      this.lstPagar[pagarIndex].ExibirHistorico = !this.lstPagar[pagarIndex].ExibirHistorico;
}

  abrirModalRecibo(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-md' });
    this.filtrarRecibos(this.lstPagarMultiplo);
  }

  fecharModalRecibo() {
    this.fecharModal();
    this.lstPagarMultiplo = [];
    this.baixasLista = [];
    this.lstRecibosBaixa = [];
    this.lstRecibos = [];
    this.lstRecibosTemp = [];
  }

  filtrarRecibos(recibos: PagarLista[]) {
    this.lstRecibosTemp = [];
    this.lstRecibosTemp = JSON.parse(JSON.stringify(recibos));

    const participantes = new Set();
    let i = 0;

    this.lstRecibosTemp.forEach((recibo) =>
      participantes.add(recibo.Participante)
    );

    participantes.forEach((participante: string) => {
      this.lstRecibos.push(new PagarLista());
      this.lstRecibos[i].Participante = participante;
      this.lstRecibos[i].Valor = this.lstRecibosTemp
        .filter((recibo) => recibo.Participante === participante)
        .reduce(
          (accumulator, currentValue) => accumulator + currentValue.Valor,
          0
        );
      i++;
    });
  }

  imprimirRecibo(index: number) {
    const newTab = window.open();
    newTab.location.href = window.location.href.split('#')[0] +
      '/#/recibo/P/' + this.lstPagar[index].Id;
  }

  imprimirSelecionados(index: number) {
    if (this.lstRecibosBaixa.length !== 0) {
      this.lstRecibosBaixa = [];
    }
    this.lstPagarMultiplo.forEach((item) => {
      if (this.lstRecibos[index].Participante === item.Participante) {
        const temp = new Baixa();
        item.DataPagamento = (new Date(this.dataPagamento)).toISOString();
        temp.formaDePagamentoCodigo = String(
          this.formaDePagamento.formaDePagamentoId
        );
        temp.dataPagamento = this.dataPagamento;
        temp.Tipo = 'P';
        temp.documentoId = item.Id;
        temp.valor = item.Valor;
        temp.formaDePagamento[0] = this.formaDePagamento;
        temp.formaDePagamento[0].valor = item.Valor;

        this.lstRecibosBaixa.push(temp);
      }
    });

    this.pagarService.emitirRecibos(this.lstRecibosBaixa);
  }
}
